// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.searchable-select {
  position: relative;
  width: 100%;
}
.searchable-select .select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 2.375rem;
  padding: 0.75rem 1rem;
  background-color: #fff;
  border: 2px solid #e9ecef;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}
html[data-coreui-theme=dark] .searchable-select .select-trigger {
  background-color: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
}
.searchable-select .select-trigger:hover:not(.disabled .select-trigger) {
  border-color: #667eea;
}
.searchable-select .select-trigger:focus, .searchable-select .select-trigger.open {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}
.searchable-select .select-trigger .select-value {
  flex: 1 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.875rem;
  color: #495057;
}
html[data-coreui-theme=dark] .searchable-select .select-trigger .select-value {
  color: var(--cui-body-color, #fff);
}
.searchable-select .select-trigger .select-value .placeholder {
  color: #adb5bd;
  font-style: italic;
}
html[data-coreui-theme=dark] .searchable-select .select-trigger .select-value .placeholder {
  color: var(--cui-secondary-color, #8a93a2);
}
.searchable-select .select-trigger .select-icons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
.searchable-select .select-trigger .select-icons .clear-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border: none;
  background: transparent;
  border-radius: 50%;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}
.searchable-select .select-trigger .select-icons .clear-btn:hover {
  background-color: rgba(108, 117, 125, 0.1);
  color: #495057;
  transform: scale(1.1);
}
html[data-coreui-theme=dark] .searchable-select .select-trigger .select-icons .clear-btn {
  color: var(--cui-secondary-color, #8a93a2);
}
html[data-coreui-theme=dark] .searchable-select .select-trigger .select-icons .clear-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--cui-body-color, #fff);
}
.searchable-select .select-trigger .select-icons .chevron {
  color: #6c757d;
  transition: transform 0.3s ease;
}
html[data-coreui-theme=dark] .searchable-select .select-trigger .select-icons .chevron {
  color: var(--cui-secondary-color, #8a93a2);
}
.searchable-select .select-trigger .select-icons .chevron.rotated {
  transform: rotate(180deg);
}
.searchable-select .select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1050;
  background: #fff;
  border: 2px solid #667eea;
  border-top: none;
  border-radius: 0 0 0.5rem 0.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown {
  background: var(--cui-dark-bg, #212631);
  border-color: var(--cui-primary, #0d6efd);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}
.searchable-select .select-dropdown .search-container {
  position: relative;
  padding: 0.75rem;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .search-container {
  background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.searchable-select .select-dropdown .search-container .search-icon {
  position: absolute;
  left: 1.25rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  z-index: 1;
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .search-container .search-icon {
  color: var(--cui-secondary-color, #8a93a2);
}
.searchable-select .select-dropdown .search-container .search-input {
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2.25rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  outline: none;
  transition: all 0.2s ease;
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .search-container .search-input {
  background-color: var(--cui-dark-bg, #212631);
  border-color: var(--cui-dark-border-subtle, #333);
  color: var(--cui-body-color, #fff);
}
.searchable-select .select-dropdown .search-container .search-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);
}
.searchable-select .select-dropdown .search-container .search-input::placeholder {
  color: #adb5bd;
  font-style: italic;
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .search-container .search-input::placeholder {
  color: var(--cui-secondary-color, #8a93a2);
}
.searchable-select .select-dropdown .options-container {
  max-height: 200px;
  overflow-y: auto;
  padding: 0.25rem 0;
}
.searchable-select .select-dropdown .options-container::-webkit-scrollbar {
  width: 6px;
}
.searchable-select .select-dropdown .options-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.searchable-select .select-dropdown .options-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 3px;
}
.searchable-select .select-dropdown .options-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5a6fd8, #6a42a0);
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .options-container::-webkit-scrollbar-track {
  background: var(--cui-dark-bg-subtle, #2c3034);
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .options-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #4a5568, #2d3748);
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .options-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #2d3748, #1a202c);
}
.searchable-select .select-dropdown .options-container .option-item {
  padding: 0.75rem 1rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #495057;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  position: relative;
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .options-container .option-item {
  color: var(--cui-body-color, #fff);
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
.searchable-select .select-dropdown .options-container .option-item:last-child {
  border-bottom: none;
}
.searchable-select .select-dropdown .options-container .option-item:hover, .searchable-select .select-dropdown .options-container .option-item.highlighted {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  color: #667eea;
  padding-left: 1.5rem;
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .options-container .option-item:hover, html[data-coreui-theme=dark] .searchable-select .select-dropdown .options-container .option-item.highlighted {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
  color: var(--cui-primary, #0d6efd);
}
.searchable-select .select-dropdown .options-container .option-item.selected {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  position: relative;
}
.searchable-select .select-dropdown .options-container .option-item.selected::after {
  content: "✓";
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
}
.searchable-select .select-dropdown .options-container .option-item.selected:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);
  color: white;
  padding-left: 1rem;
}
.searchable-select .select-dropdown .options-container .empty-option {
  padding: 1rem;
  text-align: center;
  color: #6c757d;
  font-style: italic;
  font-size: 0.875rem;
}
html[data-coreui-theme=dark] .searchable-select .select-dropdown .options-container .empty-option {
  color: var(--cui-secondary-color, #8a93a2);
}
.searchable-select.sm .select-trigger {
  min-height: 1.9375rem;
  padding: 0.375rem 0.75rem;
  font-size: 0.8125rem;
}
.searchable-select.lg .select-trigger {
  min-height: 3rem;
  padding: 1rem 1.25rem;
  font-size: 1rem;
}
.searchable-select.is-invalid .select-trigger {
  border-color: #dc3545;
}
.searchable-select.is-invalid .select-trigger:focus, .searchable-select.is-invalid .select-trigger.open {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
.searchable-select.is-invalid .select-dropdown {
  border-color: #dc3545;
}
.searchable-select.disabled {
  opacity: 0.6;
  pointer-events: none;
}
.searchable-select.disabled .select-trigger {
  background-color: #f8f9fa;
  cursor: not-allowed;
}
html[data-coreui-theme=dark] .searchable-select.disabled .select-trigger {
  background-color: var(--cui-dark-bg-subtle, #2c3034);
}
.weave-table .searchable-select .select-trigger {
  min-height: 2rem;
  padding: 0.375rem 0.5rem;
  font-size: 0.75rem;
  border-radius: 8px;
  border-width: 1px;
}
.weave-table .searchable-select .select-trigger .select-value {
  font-size: 0.75rem;
}
.weave-table .searchable-select .select-trigger .select-icons {
  gap: 0.25rem;
}
.weave-table .searchable-select .select-trigger .select-icons .clear-btn {
  width: 1rem;
  height: 1rem;
}
.weave-table .searchable-select .select-dropdown {
  border-width: 1px;
  max-height: 250px;
}
.weave-table .searchable-select .select-dropdown .search-container {
  padding: 0.5rem;
}
.weave-table .searchable-select .select-dropdown .search-container .search-input {
  padding: 0.375rem 0.5rem 0.375rem 1.75rem;
  font-size: 0.75rem;
}
.weave-table .searchable-select .select-dropdown .search-container .search-icon {
  left: 1rem;
}
.weave-table .searchable-select .select-dropdown .options-container {
  max-height: 150px;
}
.weave-table .searchable-select .select-dropdown .options-container .option-item {
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
}
.weave-table .searchable-select .select-dropdown .options-container .option-item:hover, .weave-table .searchable-select .select-dropdown .options-container .option-item.highlighted {
  padding-left: 1rem;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .searchable-select .select-dropdown {
    max-height: 250px;
  }
  .searchable-select .select-dropdown .options-container {
    max-height: 150px;
  }
  .searchable-select.weave-table .select-dropdown {
    max-height: 200px;
  }
  .searchable-select.weave-table .select-dropdown .options-container {
    max-height: 120px;
  }
}
@media (max-width: 576px) {
  .searchable-select .select-trigger {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
  .searchable-select .select-dropdown .search-container {
    padding: 0.5rem;
  }
  .searchable-select .select-dropdown .search-container .search-input {
    font-size: 0.8rem;
  }
  .searchable-select .select-dropdown .options-container .option-item {
    padding: 0.625rem 0.75rem;
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchableSelect/SearchableSelect.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,WAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;AAEJ;AAAI;EACE,6CAAA;EACA,iDAAA;AAEN;AACI;EACE,qBAAA;AACN;AAEI;EAEE,qBAAA;EACA,8CAAA;EACA,2BAAA;AADN;AAII;EACE,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAFN;AAIM;EACE,kCAAA;AAFR;AAKM;EACE,cAAA;EACA,kBAAA;AAHR;AAKQ;EACE,0CAAA;AAHV;AAQI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AANN;AAQM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;AANR;AAQQ;EACE,0CAAA;EACA,cAAA;EACA,qBAAA;AANV;AASQ;EACE,0CAAA;AAPV;AASU;EACE,0CAAA;EACA,kCAAA;AAPZ;AAYM;EACE,cAAA;EACA,+BAAA;AAVR;AAYQ;EACE,0CAAA;AAVV;AAaQ;EACE,yBAAA;AAXV;AAiBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gCAAA;EACA,0CAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;AAfJ;AAiBI;EACE,uCAAA;EACA,yCAAA;EACA,yCAAA;AAfN;AAkBI;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,6DAAA;AAhBN;AAkBM;EACE,4GAAA;EACA,wDAAA;AAhBR;AAmBM;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,UAAA;AAjBR;AAmBQ;EACE,0CAAA;AAjBV;AAqBM;EACE,WAAA;EACA,sCAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAnBR;AAqBQ;EACE,6CAAA;EACA,iDAAA;EACA,kCAAA;AAnBV;AAsBQ;EACE,qBAAA;EACA,+CAAA;AApBV;AAuBQ;EACE,cAAA;EACA,kBAAA;AArBV;AAuBU;EACE,0CAAA;AArBZ;AA2BI;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAzBN;AA2BM;EACE,UAAA;AAzBR;AA4BM;EACE,mBAAA;EACA,kBAAA;AA1BR;AA6BM;EACE,qDAAA;EACA,kBAAA;AA3BR;AA6BQ;EACE,qDAAA;AA3BV;AAgCQ;EACE,8CAAA;AA9BV;AAiCQ;EACE,qDAAA;AA/BV;AAiCU;EACE,qDAAA;AA/BZ;AAoCM;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,4CAAA;EACA,yBAAA;EACA,kBAAA;AAlCR;AAoCQ;EACE,kCAAA;EACA,wDAAA;AAlCV;AAqCQ;EACE,mBAAA;AAnCV;AAsCQ;EAEE,8FAAA;EACA,cAAA;EACA,oBAAA;AArCV;AAuCU;EACE,8FAAA;EACA,kCAAA;AArCZ;AAyCQ;EACE,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAvCV;AAyCU;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;AAvCZ;AA0CU;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;AAxCZ;AA6CM;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA3CR;AA6CQ;EACE,0CAAA;AA3CV;AAmDI;EACE,qBAAA;EACA,yBAAA;EACA,oBAAA;AAjDN;AAsDI;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;AApDN;AA0DI;EACE,qBAAA;AAxDN;AA0DM;EAEE,qBAAA;EACA,4CAAA;AAzDR;AA6DI;EACE,qBAAA;AA3DN;AAgEE;EACE,YAAA;EACA,oBAAA;AA9DJ;AAgEI;EACE,yBAAA;EACA,mBAAA;AA9DN;AAgEM;EACE,oDAAA;AA9DR;AAqEI;EACE,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAnEN;AAqEM;EACE,kBAAA;AAnER;AAsEM;EACE,YAAA;AApER;AAsEQ;EACE,WAAA;EACA,YAAA;AApEV;AAyEI;EACE,iBAAA;EACA,iBAAA;AAvEN;AAyEM;EACE,eAAA;AAvER;AAyEQ;EACE,yCAAA;EACA,kBAAA;AAvEV;AA0EQ;EACE,UAAA;AAxEV;AA4EM;EACE,iBAAA;AA1ER;AA4EQ;EACE,uBAAA;EACA,kBAAA;AA1EV;AA4EU;EAEE,kBAAA;AA3EZ;;AAoFA;EACE;IACE,UAAA;IACA,4BAAA;EAjFF;EAmFA;IACE,UAAA;IACA,wBAAA;EAjFF;AACF;AAqFA;EAEI;IACE,iBAAA;EApFJ;EAsFI;IACE,iBAAA;EApFN;EAyFI;IACE,iBAAA;EAvFN;EAyFM;IACE,iBAAA;EAvFR;AACF;AA6FA;EAEI;IACE,uBAAA;IACA,iBAAA;EA5FJ;EAgGI;IACE,eAAA;EA9FN;EAgGM;IACE,iBAAA;EA9FR;EAmGM;IACE,yBAAA;IACA,iBAAA;EAjGR;AACF","sourcesContent":[".searchable-select {\n  position: relative;\n  width: 100%;\n\n  .select-trigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-height: 2.375rem;\n    padding: 0.75rem 1rem;\n    background-color: #fff;\n    border: 2px solid #e9ecef;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    outline: none;\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background-color: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-dark-border-subtle, #333);\n    }\n\n    &:hover:not(.disabled .select-trigger) {\n      border-color: #667eea;\n    }\n\n    &:focus,\n    &.open {\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      transform: translateY(-1px);\n    }\n\n    .select-value {\n      flex: 1;\n      text-align: left;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-size: 0.875rem;\n      color: #495057;\n      \n      html[data-coreui-theme=\"dark\"] & {\n        color: var(--cui-body-color, #fff);\n      }\n\n      .placeholder {\n        color: #adb5bd;\n        font-style: italic;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-secondary-color, #8a93a2);\n        }\n      }\n    }\n\n    .select-icons {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      flex-shrink: 0;\n\n      .clear-btn {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 1.25rem;\n        height: 1.25rem;\n        border: none;\n        background: transparent;\n        border-radius: 50%;\n        color: #6c757d;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        padding: 0;\n\n        &:hover {\n          background-color: rgba(108, 117, 125, 0.1);\n          color: #495057;\n          transform: scale(1.1);\n        }\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-secondary-color, #8a93a2);\n          \n          &:hover {\n            background-color: rgba(255, 255, 255, 0.1);\n            color: var(--cui-body-color, #fff);\n          }\n        }\n      }\n\n      .chevron {\n        color: #6c757d;\n        transition: transform 0.3s ease;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-secondary-color, #8a93a2);\n        }\n\n        &.rotated {\n          transform: rotate(180deg);\n        }\n      }\n    }\n  }\n\n  .select-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 1050;\n    background: #fff;\n    border: 2px solid #667eea;\n    border-top: none;\n    border-radius: 0 0 0.5rem 0.5rem;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n    max-height: 300px;\n    overflow: hidden;\n    animation: slideDown 0.2s ease-out;\n    \n    html[data-coreui-theme=\"dark\"] & {\n      background: var(--cui-dark-bg, #212631);\n      border-color: var(--cui-primary, #0d6efd);\n      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n    }\n\n    .search-container {\n      position: relative;\n      padding: 0.75rem;\n      border-bottom: 1px solid #e9ecef;\n      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background: linear-gradient(135deg, var(--cui-dark-bg-subtle, #2c3034) 0%, var(--cui-dark-bg, #212631) 100%);\n        border-bottom-color: var(--cui-dark-border-subtle, #333);\n      }\n\n      .search-icon {\n        position: absolute;\n        left: 1.25rem;\n        top: 50%;\n        transform: translateY(-50%);\n        color: #6c757d;\n        z-index: 1;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-secondary-color, #8a93a2);\n        }\n      }\n\n      .search-input {\n        width: 100%;\n        padding: 0.5rem 0.75rem 0.5rem 2.25rem;\n        border: 1px solid #ced4da;\n        border-radius: 0.375rem;\n        font-size: 0.875rem;\n        outline: none;\n        transition: all 0.2s ease;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          background-color: var(--cui-dark-bg, #212631);\n          border-color: var(--cui-dark-border-subtle, #333);\n          color: var(--cui-body-color, #fff);\n        }\n\n        &:focus {\n          border-color: #667eea;\n          box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.25);\n        }\n\n        &::placeholder {\n          color: #adb5bd;\n          font-style: italic;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            color: var(--cui-secondary-color, #8a93a2);\n          }\n        }\n      }\n    }\n\n    .options-container {\n      max-height: 200px;\n      overflow-y: auto;\n      padding: 0.25rem 0;\n\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 3px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: linear-gradient(135deg, #667eea, #764ba2);\n        border-radius: 3px;\n\n        &:hover {\n          background: linear-gradient(135deg, #5a6fd8, #6a42a0);\n        }\n      }\n      \n      html[data-coreui-theme=\"dark\"] & {\n        &::-webkit-scrollbar-track {\n          background: var(--cui-dark-bg-subtle, #2c3034);\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: linear-gradient(135deg, #4a5568, #2d3748);\n\n          &:hover {\n            background: linear-gradient(135deg, #2d3748, #1a202c);\n          }\n        }\n      }\n\n      .option-item {\n        padding: 0.75rem 1rem;\n        cursor: pointer;\n        font-size: 0.875rem;\n        color: #495057;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n        transition: all 0.2s ease;\n        position: relative;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-body-color, #fff);\n          border-bottom-color: var(--cui-dark-border-subtle, #333);\n        }\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        &:hover,\n        &.highlighted {\n          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n          color: #667eea;\n          padding-left: 1.5rem;\n          \n          html[data-coreui-theme=\"dark\"] & {\n            background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);\n            color: var(--cui-primary, #0d6efd);\n          }\n        }\n\n        &.selected {\n          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n          color: white;\n          font-weight: 600;\n          position: relative;\n\n          &::after {\n            content: '✓';\n            position: absolute;\n            right: 1rem;\n            top: 50%;\n            transform: translateY(-50%);\n            font-weight: bold;\n          }\n\n          &:hover {\n            background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);\n            color: white;\n            padding-left: 1rem;\n          }\n        }\n      }\n\n      .empty-option {\n        padding: 1rem;\n        text-align: center;\n        color: #6c757d;\n        font-style: italic;\n        font-size: 0.875rem;\n        \n        html[data-coreui-theme=\"dark\"] & {\n          color: var(--cui-secondary-color, #8a93a2);\n        }\n      }\n    }\n  }\n\n  // Size variants\n  &.sm {\n    .select-trigger {\n      min-height: 1.9375rem;\n      padding: 0.375rem 0.75rem;\n      font-size: 0.8125rem;\n    }\n  }\n\n  &.lg {\n    .select-trigger {\n      min-height: 3rem;\n      padding: 1rem 1.25rem;\n      font-size: 1rem;\n    }\n  }\n\n  // Invalid state\n  &.is-invalid {\n    .select-trigger {\n      border-color: #dc3545;\n\n      &:focus,\n      &.open {\n        border-color: #dc3545;\n        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n      }\n    }\n\n    .select-dropdown {\n      border-color: #dc3545;\n    }\n  }\n\n  // Disabled state\n  &.disabled {\n    opacity: 0.6;\n    pointer-events: none;\n\n    .select-trigger {\n      background-color: #f8f9fa;\n      cursor: not-allowed;\n      \n      html[data-coreui-theme=\"dark\"] & {\n        background-color: var(--cui-dark-bg-subtle, #2c3034);\n      }\n    }\n  }\n\n  // Table-specific styles\n  .weave-table & {\n    .select-trigger {\n      min-height: 2rem;\n      padding: 0.375rem 0.5rem;\n      font-size: 0.75rem;\n      border-radius: 8px;\n      border-width: 1px;\n\n      .select-value {\n        font-size: 0.75rem;\n      }\n\n      .select-icons {\n        gap: 0.25rem;\n\n        .clear-btn {\n          width: 1rem;\n          height: 1rem;\n        }\n      }\n    }\n\n    .select-dropdown {\n      border-width: 1px;\n      max-height: 250px;\n\n      .search-container {\n        padding: 0.5rem;\n\n        .search-input {\n          padding: 0.375rem 0.5rem 0.375rem 1.75rem;\n          font-size: 0.75rem;\n        }\n\n        .search-icon {\n          left: 1rem;\n        }\n      }\n\n      .options-container {\n        max-height: 150px;\n\n        .option-item {\n          padding: 0.5rem 0.75rem;\n          font-size: 0.75rem;\n\n          &:hover,\n          &.highlighted {\n            padding-left: 1rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Animation\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .searchable-select {\n    .select-dropdown {\n      max-height: 250px;\n\n      .options-container {\n        max-height: 150px;\n      }\n    }\n\n    &.weave-table {\n      .select-dropdown {\n        max-height: 200px;\n\n        .options-container {\n          max-height: 120px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .searchable-select {\n    .select-trigger {\n      padding: 0.5rem 0.75rem;\n      font-size: 0.8rem;\n    }\n\n    .select-dropdown {\n      .search-container {\n        padding: 0.5rem;\n\n        .search-input {\n          font-size: 0.8rem;\n        }\n      }\n\n      .options-container {\n        .option-item {\n          padding: 0.625rem 0.75rem;\n          font-size: 0.8rem;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
